import React from 'react';

import { IIconProps, TIconType } from '../interface';

const ChartsOnMapIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-id='icon'
			data-testid='chartsOnMap'
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<path
				d='M21 19.5H3V4.5'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M19.5 6L12 13.5L9 10.5L3 16.5'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M19.5 9.75V6H15.75'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default ChartsOnMapIcon;
